import type React from 'react';

import type { CellContext, HeaderContext } from '@tanstack/react-table';
import type { Card } from '@vlabs/api/point-api/model';
import type { TBuildTableViewCell } from '@vlabs/monokit/shared/ui/table-view';
import { buildTableViewCell } from '@vlabs/monokit/shared/ui/table-view';

// FIXME: Спустить это всё в TableView
type TSharedCtx<TValue = unknown> = CellContext<Card, TValue> | HeaderContext<Card, TValue>;

const dataTestIdFromCtx = <TValue extends React.ReactNode>(
  ctx: TSharedCtx<TValue>,
): {
  'data-testid': string;
} | undefined => {
  if (!ctx) return undefined;
  if ((ctx as CellContext<Card, TValue>).row) {
    return {
      'data-testid': `${ctx.column.id}.cell.${(ctx as CellContext<Card, TValue>).row.original.card_id}`,
    };
  }
  return {
    'data-testid': `${ctx.column.id}.header`,
  };
};

export function renderHeader<TValue extends React.ReactNode>(
  renderer: (ctx: TSharedCtx<TValue>) => TBuildTableViewCell,
  value: React.ReactNode = '',
) {
  return (header: HeaderContext<Card, TValue>): React.JSX.Element => renderer(header)(value);
}

export function renderCell<TValue extends React.ReactNode>(
  renderer: (ctx: TSharedCtx<TValue>) => TBuildTableViewCell,
  wrap?: (ctx: CellContext<Card, TValue>) => React.ReactNode,
) {
  return (ctx: CellContext<Card, TValue>): React.JSX.Element => renderer(ctx)(
    wrap
      ? wrap?.(ctx)
      : ctx.getValue(),
  );
}

export const photoCell = (ctx: TSharedCtx<string>): TBuildTableViewCell => buildTableViewCell({
  style: {
    flex: '0 0 104px',
    padding: '8px 16px',
  },
  ...dataTestIdFromCtx<string>(ctx),
});

export const cardIdCell = (ctx: TSharedCtx<string>): TBuildTableViewCell => buildTableViewCell({
  style: {
    flex: '0 0 200px',
    maxWidth: '200px',
  },
  ...dataTestIdFromCtx<string>(ctx),
});

export const userDataCell = (ctx: TSharedCtx<string>): TBuildTableViewCell => buildTableViewCell({
  style: {
    flex: '1 1 200px',
    maxWidth: '360px',
    minWidth: '200px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  ...dataTestIdFromCtx<string>(ctx),
});

export const createTimeCell = (ctx: TSharedCtx<string>): TBuildTableViewCell => buildTableViewCell({
  style: {
    flex: '0 0 200px',
    marginRight: 'auto',
  },
  ...dataTestIdFromCtx<string>(ctx),
});

export const listsCell = (ctx: TSharedCtx<Lists>): TBuildTableViewCell => buildTableViewCell({
  style: {
    flex: '1',
    minWidth: '300px',
  },
  ...dataTestIdFromCtx<string>(ctx),
});

export const actionCell = (ctx: TSharedCtx<string>): TBuildTableViewCell => buildTableViewCell({
  style: {
    flex: '0 0 40px',
    padding: 0,
  },
  ...dataTestIdFromCtx<string>(ctx),
});
export const dividerCell = buildTableViewCell({
  style: {
    flex: '0 0 16px',
    padding: 0,
  },
});
